import extandDayjs from 'dayjs'

var localeData = require('dayjs/plugin/localeData')
var localizedFormat = require('dayjs/plugin/localizedFormat')
var relativeTime = require('dayjs/plugin/relativeTime')
require('./dayjs-ar-sa')

extandDayjs.extend(relativeTime)
extandDayjs.extend(localeData)
extandDayjs.extend(localizedFormat)
extandDayjs.locale('ar-sa')

export default extandDayjs